import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'

import Typography from './Typography'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.fadedPurple.main,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    '& .MuiFormControl-marginNormal': {
      marginTop: theme.spacing(1),
    },
    '& .MuiFilledInput-root': {
      backgroundColor: 'white',
      border: `1px solid ${theme.palette.fadedPurple.main}`,
      '&.Mui-focused': {
        borderColor: theme.palette.lightPurple.main,
      },
      '&:hover': {
        borderColor: theme.palette.lightPurple.main,
      },
    },
  },
  checkboxGroup: {
    backgroundColor: 'white',
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(0.5, 1.5),
  },
  inputGroup: {
    marginBottom: theme.spacing(3),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  inputSubGroup: {
    marginBottom: theme.spacing(3),
    '&:last-child': {
      marginBottom: 0,
    },
    marginTop: theme.spacing(3),
  },
  inputRow: {
    '& > *': {
      marginRight: theme.spacing(2),
      '&:last-child': {
        marginRight: 0,
      },
    },
  },
}))

const Form = ({ className, ...props }) => {
  const classes = useStyles()

  return <form className={clsx(classes.root, className)} {...props} />
}

const InputGroup = ({ children, className, title }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.inputGroup, className)}>
      {title && (
        <Typography variant="h4" color="primary">
          {title}
        </Typography>
      )}
      {children}
    </div>
  )
}

const InputSubGroup = ({ children, className, title }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.inputSubGroup, className)}>
      {title && (
        <Typography variant="h5" color="primary">
          {title}
        </Typography>
      )}
      {children}
    </div>
  )
}

const CheckboxGroup = ({ children, title }) => {
  const classes = useStyles()

  return (
    <div className={classes.checkboxGroup}>
      {title && (
        <Typography variant="h4" color="primary">
          {title}
        </Typography>
      )}
      {children}
    </div>
  )
}

const InputRow = ({ children }) => {
  const classes = useStyles()

  return <div className={classes.inputRow}>{children}</div>
}

Form.CheckboxGroup = CheckboxGroup
Form.InputGroup = InputGroup
Form.InputRow = InputRow
Form.InputSubGroup = InputSubGroup

export default Form
